import { render, staticRenderFns } from "./requirementDetail.vue?vue&type=template&id=e561c54a&scoped=true"
import script from "./requirementDetail.vue?vue&type=script&lang=js"
export * from "./requirementDetail.vue?vue&type=script&lang=js"
import style0 from "./requirementDetail.vue?vue&type=style&index=0&id=e561c54a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e561c54a",
  null
  
)

export default component.exports